/**
 * Check if the date is a weekend day
 * @param {Date} date The date to check.
 * @param {number[]} weekendDays The weekend days.
 * @returns {boolean} Whether the date is a weekend day.
 */
export default function isWeekend(date, weekendDays = [0, 6]) {
    return weekendDays.includes(date.getDay());
}
